import './delivery-model-selection.scss';

import { faMoped } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colors } from '@/Themes/Colors';
import {
  ENUM_DELIVERY_MODEL_LABELS,
  DELIVERY_MODEL_OPTIONS,
} from '../../constants';
import { useAppDispatch, useAppSelector } from '@/_store/hooks';
import { setSelectedsDeliveryModel } from '@/_store/modules/delivery-model/slice';
import { DropdownInput } from '@/_components/dropdown-input/dropdown-input';

export const DeliveryModelSelection = () => {
  const dispatch = useAppDispatch();
  const selectedsDeliveryModel = useAppSelector(
    state => state.deliveryModel.selectedsDeliveryModel,
  );

  const handleChangeSelectedsDeliveryModel = (
    deliveryModels: ENUM_DELIVERY_MODEL_LABELS[],
  ) => {
    dispatch(setSelectedsDeliveryModel(deliveryModels));
  };

  const DELIVERYMAN_MODEL_LABELS = [
    ENUM_DELIVERY_MODEL_LABELS.OWN_DELIVERYMAN,
    ENUM_DELIVERY_MODEL_LABELS.CLOUD_DELIVERYMAN,
    ENUM_DELIVERY_MODEL_LABELS.OWN_AND_CLOUD_DELIVERYMAN,
  ];

  const PLACE_MODEL_LABELS = [
    ENUM_DELIVERY_MODEL_LABELS.OWN_PLACE,
    ENUM_DELIVERY_MODEL_LABELS.CLOUD_PLACE,
    ENUM_DELIVERY_MODEL_LABELS.OWN_AND_CLOUD_PLACE,
  ];

  const handleDeliveryModelChange = (data: string[]) => {
    const selectedValues = data as ENUM_DELIVERY_MODEL_LABELS[];
    const allIndex = selectedValues.indexOf(ENUM_DELIVERY_MODEL_LABELS.ALL);

    if (allIndex === 0 && selectedValues.length > 1) {
      selectedValues.splice(allIndex, 1);
    }

    if (allIndex > 0) {
      handleChangeSelectedsDeliveryModel([ENUM_DELIVERY_MODEL_LABELS.ALL]);
      return;
    }

    const lastSelected = selectedValues[selectedValues.length - 1];

    if (DELIVERYMAN_MODEL_LABELS.includes(lastSelected)) {
      const placeSelected = selectedValues.find(model =>
        PLACE_MODEL_LABELS.includes(model),
      );
      if (placeSelected) {
        handleChangeSelectedsDeliveryModel([lastSelected, placeSelected]);
        return;
      }
      handleChangeSelectedsDeliveryModel([lastSelected]);
      return;
    }

    if (PLACE_MODEL_LABELS.includes(lastSelected)) {
      const deliverymanSelected = selectedValues.find(model =>
        DELIVERYMAN_MODEL_LABELS.includes(model),
      );
      if (deliverymanSelected) {
        handleChangeSelectedsDeliveryModel([deliverymanSelected, lastSelected]);
        return;
      }
      handleChangeSelectedsDeliveryModel([lastSelected]);
      return;
    }

    handleChangeSelectedsDeliveryModel(selectedValues);
  };

  return (
    <div className="delivery-model-selection-container">
      <div className="icon-delivery-model-container">
        <div className="icon-delivery-model">
          <FontAwesomeIcon icon={faMoped} color={colors.brand10} />
        </div>
        <span className="subtitle1">Modelo de entrega</span>
      </div>
      <div>
        <DropdownInput
          search
          options={DELIVERY_MODEL_OPTIONS}
          value={selectedsDeliveryModel}
          className="delivery-model"
          onChange={data => {
            handleDeliveryModelChange(data as string[]);
          }}
          multiple
          containerClassName="delivery-model-selection"
          labelClassName="delivery-model-label"
        />
      </div>
    </div>
  );
};
